import type { FunctionComponent } from 'react'
import { PageTitle } from '@which/seatbelt'

import type { ToolHeadingProps } from '../../types/toolTypes'
import styles from './ToolHeading.module.scss'

export const ToolHeading: FunctionComponent<ToolHeadingProps> = ({ title }) => (
  <div className={styles.toolHeading}>
    <PageTitle pageTitle={title} pageTitleTag="h1" />
  </div>
)
